import { ApiLoadingState } from '../../../middleware/api/apiList'
import { IncomingEmpDepartment } from '../../Checklist/ChecklistTypes'
import { ValidationError } from '../../commonTypes'

export interface IncomingReviewListCycle {
  id: number
  name: string
  description: string | null
  toDate: string
  fromDate: string
  active: boolean
  appraisalType: string
  appraisalDuration: string
  level: number
  cycleStartedFlag: boolean
  appraisalStartDate: string
  appraisalEndDate: string
  servicePeriod: number
}

export interface IncomingReviewListDesignation {
  id: number
  name: string
  code: null
  departmentName: string
  departmentId: number
}

export enum ReviewListEmpStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}
// enum values here are important as they are api values
export enum ReviewListRoleEnum {
  employeeName = 'EmpName',
  managerName = 'AddedBy',
}

export enum ReviewListDateEnum {
  fromDate = 'From',
  toDate = 'To',
}

export enum RatingCheckEnum {
  checkAll = 'Check All',
  uncheckAll = 'Uncheck All',
  checkNum = 'Check Num',
  unCheckNum = 'Uncheck Num',
}

export interface ReviewListItem {
  id: number
  empId: number | null
  employeeName: string | null
  formStatus: string
  formStatusvalue: number
  appraisalFormStatus: null
  overallAvgRating: string | number // string - if NaN value is coming
  finalRating: null
  pendingWith: string | null
  empDepartmentName: string | null
  empDesignationName: string | null
  empAvgRating: number | null
  manager1Name: string
  cycleStartDate: string
}

export interface IncomingReviewList {
  size: number
  list: ReviewListItem[]
}

export interface OutgoingGetReviewListProps {
  appraisalFormStatus: string
  cycleId: number | string // string value for none-selected cycle id.
  departmentName: string
  designationName: string
  employeeID?: number | string
  searchString: string
  role: string
  startIndex: number
  endIndex: number
  ratings: string[]
  empStatus: string
  fromDate: null | string
  toDate: null | string
  country: string
  employmentType: string
}

export interface ReviewListSliceState {
  isLoading: ApiLoadingState
  error: ValidationError
  empDepartments: IncomingEmpDepartment[]
  activeCycle: IncomingReviewListCycle | string // returns empty String if no active cycle
  allCycles: IncomingReviewListCycle[]
  incomingReviewList: IncomingReviewList
  incomingDesignations: IncomingReviewListDesignation[]
  outgoingReviewListProperties: OutgoingGetReviewListProps
  appraisalStatus: string
  selectedItemID: string
  isView: boolean
  isCall: boolean
}
